import './App.css';
import Card from './components/Card.js'
import Tilt from 'react-parallax-tilt';
import About from './components/About';
import Footer from './components/Footer';
import Project from './components/Project';
import Skills from './components/Skills';
import Achieve from './components/Achieve';
import Edu from './components/Edu';

function App() {
  return ( 
    <div className="min-h-screen py-20 px-3 sm:px-5 bg-gray-900 max-w-screen overflow-hidden">
      <div className='lg:h-38-r lg:w-38-r lg:bg-gradient-to-r from-green-400 to-blue-500 rounded-full absolute left-0 right-0 mx-auto sm:bottom-96 2xl:-top-96 md:animate-spin'></div>

      <div className='sm:h-15-r sm:w-15-r sm:bg-gradient-to-r sm:from-red-400 sm:via-pink-500 sm:to-purple-500 rounded-full absolute top-96 left-20 animate-spin'></div>
      <div className='h-10-r w-10-r bg-gradient-to-r from-red-300 via-white-100 to-pink-600 rounded-full absolute top-60 left-20 animate-bounce'></div>
      <div className='h-8-r w-8-r bg-gradient-to-r from-purple-600 via-pink-400 to-red-300 rounded-full absolute bottom-80 left-40 animate-bounce'></div>
      <div className='h-6-r w-6-r bg-gradient-to-r from-purple-200 via-pink-500 to-pink-700 rounded-full absolute top-20 left-20 animate-bounce'></div>

      <div className='h-15-r w-15-r bg-gradient-to-r from-rose-700 via-yellow-500 to-orange-200 rounded-full absolute top-96 right-10 animate-bounce'></div>
      <div className='h-10-r w-10-r bg-gradient-to-r from-slate-100 via-orange-400 to-rose-500 rounded-full absolute top-80 right-10 animate-pulse'></div>
      <div className='h-6-r w-6-r bg-gradient-to-r from-red-800 via-rose-400 to-orange-300 rounded-full absolute top-60 right-10 animate-bounce'></div>
        <Tilt>
          <Card/>
        </Tilt>
        <About/>
        <Project/>
        <Skills/>
        <Edu/>
        <Achieve/>
        <Footer/>
        
    </div>
  );
}

export default App;
